import { QueryClient } from '@tanstack/react-query'
import { queryKeys } from './queryKeys'

export function createQueryClient(): QueryClient {
  const client = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5, // 5min default
        gcTime: 1000 * 60 * 30,   // 30min
        retry: 1,
        refetchOnWindowFocus: true,
      },
    },
  })

  // Defaults por prefixo de queryKey
  client.setQueryDefaults(queryKeys.auth.all(), {
    staleTime: 1000 * 60, // 1min para auth.me
    refetchOnWindowFocus: false,
  })

  client.setQueryDefaults(queryKeys.dashboard.all(), {
    staleTime: 1000 * 60 * 2, // 2min — dados que mudam mais
  })

  return client
}

export const queryClient = createQueryClient()
